export const LIBRARY = '/library'
export const LIBRARY_PATH = '/library/:path'
